<template>
  <HcCardBox>

     <h5
        class="card-title font-weight-bold mb-3"
        v-if="exibeTitulo">
        {{ $t(titulo) }}
      </h5>

    <slot />

    <slot name="footer">
      <div slot="footer" class="text-right">
        <slot name="pre-footer" />
        <b-button @click="onCancelar" variant="link">
          {{ $t("label.cancelar") }}
        </b-button>

        <b-button :disabled="!formValid" @click="onSalvar" variant="primary">
          {{ $t("label.salvar") }}
        </b-button>
        <slot name="post-footer" />
      </div>
    </slot>
  </HcCardBox>
</template>

<script>
import { get } from "lodash-es";
import { HcCardBox } from "../containers";

export default {
  components: {
    HcCardBox
  },
  model: {
    prop: "request",
    event: "load"
  },
  props: {
    request: Object,
    pathApi: String,
    onBeforeSalvar: Function,
    salvar: Function,
    cancelar: {
      type: Function,
      default: null
    },
    formValid: Boolean,
    rotaRetorno: {
      type: String,
      default: null
    },
    saiAoSalvar: {
      type: Boolean,
      default: true
    },
    loadDados: {
      type: Boolean,
      default: true
    },
    titulo: String,
      exibeTitulo: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      localRequest: {},
      rotaRetornoLocal: null
    };
  },
  mounted,
  methods: {
    onCancelar,
    onSalvar,
    load
  },
  notifications: {
    notificarSucesso: {
      type: "success"
    }
  }
};

function onCancelar() {
  if (this.cancelar === null) {
    this.$router.push({ name: this.rotaRetornoLocal });
  } else {
    this.cancelar();
  }
}

function onSalvar() {
  if (this.salvar == null) {
    this.onBeforeSalvar();
    if (this.formValid) {
      this.$axios
        .$post(`api/${this.pathApi}/salvar`, this.request)
        .then(resp => {
          if (this.rotaRetornoLocal && this.saiAoSalvar) {
            this.$router.push({ name: this.rotaRetornoLocal });
          }

          this.notificarSucesso({
            title: this.$t("msg.sucesso"),
            message: this.$t("msg.item_salvo_sucesso")
          });
          this.request.id = resp.id;
          this.$emit("salvar", resp);
        })
        .catch(err => {
          const erro = get(err, "response.data.message");
          this.$notify({
            title: this.$t("title.erro"),
            message: this.$t("erro." + erro),
            type: "error"
          });
        });
    }
  } else {
    this.salvar();
  }
}

async function mounted() {
  if (this.rotaRetorno != null) {
    this.rotaRetornoLocal = this.rotaRetorno;
  } else {
    this.rotaRetornoLocal = this.$route.name.replace("-edicao-id", "");
  }

  if (this.loadDados && this.$route.params.id) {
    this.load(this.$route.params.id);
  }
}

async function load(id) {
  this.localRequest = await this.$axios.$get(`api/${this.pathApi}/${id}`);
  this.$emit("load", this.localRequest);
}
</script>
